import axios from "axios";
import { API_URL } from "../../../config.tsx";

/**
 * Запрос полного списка данных автомобиля из Laximo
 * @param vehicleId - ID автомобиля
 * @param catalog - каталог автомобиля
 * @param ssd - SSD автомобиля
 * @returns
 */
export const carVehicleDataRequest = (vehicleId: string, catalog: string, ssd: string) => {
    return axios.get(`${API_URL}/find_by_vehicle_id?vehicleId=${vehicleId}&catalog=${catalog}&ssd=${ssd}`, {
        withCredentials: true,
    }).then(response => response.data);
};
